import React, { useState } from "react";
import { Form, Modal } from "react-bootstrap";

const CommentDialog = ({ isOpen, onClose, handleComment, message }) => {
  const [comment, setComment] = useState("");

  const handleSubmit = () => {
    handleComment(comment); // Envoie le commentaire au parent
    setComment(""); // Réinitialise le champ
    onClose(false); // Ferme le modal
  };

  return (
    <Modal show={isOpen} onHide={() => onClose(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>{message}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="commentForm">
          <Form.Label>Votre commentaire</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Saisissez votre commentaire ici..."
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={() => onClose(false)}>
          Annuler
        </button>
        <button
          className="btn btn-success"
          onClick={handleSubmit}
          disabled={!comment.trim()} // Désactive si commentaire vide
        >
          Confirmer
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CommentDialog;
